export const buildInventoryDisplayName = ({
  name,
  brand,
  size_label,
  display_name,
} = {}) => {
  const semanticDisplay = [name, size_label, brand]
    .map(value => String(value || '').trim())
    .filter(Boolean)
    .join(' - ');

  if (semanticDisplay) return semanticDisplay;

  const explicitDisplay = String(display_name || '').trim();
  if (explicitDisplay) return explicitDisplay;

  return '';
};

export const normalizeInventoryProfile = (item = {}) => {
  const displayName = buildInventoryDisplayName(item);
  return {
    ...item,
    brand: item.brand || '',
    size_label: item.size_label || '',
    item_notes: item.item_notes || '',
    display_name: displayName,
    search_name: item.search_name || [
      displayName,
      item.name,
      item.brand,
      item.size_label,
      item.unit,
      item.business_category,
    ].map(value => String(value || '').toLowerCase()).join(' '),
  };
};

export const inventoryOptionLabel = (item = {}) => {
  const displayName = buildInventoryDisplayName(item) || 'Unnamed item';
  const unit = item.unit ? ` (${item.unit})` : '';
  const category = item.business_category ? ` - ${item.business_category}` : '';
  return `${displayName}${unit}${category}`;
};
